export default "__VITE_ASSET__poX87dYS__"